<template>
  <div class="client-confirm__item">
    <div class="client-confirm__service">
      <h3 class="client-confirm__service-title">Выбранная услуга</h3>
      <h3 class="client-confirm__service-name">{{concreteServiceLevel && concreteServiceLevel.name}}</h3>
      <div class="client-confirm__type">
        {{concreteService && concreteService.name}},
        {{concreteService && concreteService.is_fixed_price ? '' : 'от'}}
        {{concreteService && concreteService.price}}₽
      </div>
      <div
        class="client-confirm__param"
        v-for="(option, index) in options"
        :key="index"
      >{{option ? option.name : ''}}, {{option ? (option.price - 0) : 0}}₽</div>
    </div>
    <div class="client-confirm__master">
      <h3 class="client-confirm__master-title">Мастер и время</h3>
      <div class="client-confirm__master-wrap">
        <img
          v-if="master && master.photo != null"
          :src="SERVER_URL+master.photo"
          alt
          class="client-confirm__img"
        >
        <img v-else alt src="../../assets/img/Group_2.svg" class="client-confirm__img">
        <div class="client-confirm__master-info">
          <h4 class="client-confirm__name">{{master && master.full_name}}</h4>
          <div class="client-confirm__time">{{service.date}}, {{service.time[0]}}</div>
        </div>
      </div>
      <div class="client-confirm__buttons">
        <router-link
          class="client-confirm__edit"
          :to="`/company/${cid}/${sid}/client-service`"
          @click.native="handleEdit"
        >изменить</router-link>
        <button class="client-confirm__delete" type="button" @click="handleDelete">удалить</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "OneConfirm",
  props: {
    service: Object,
    idx: Number,
    sid: String,
    cid: String
  },
  computed: {
    ...mapState("client", ["date", "currentSalonId", "companyId"]),
    ...mapGetters("salons", [
      "getMaster",
      "getSubService",
      "getConcreteService"
    ]),

    subService() {
      const { serviceId, subServiceId } = this.service;
      return this.getSubService(this.currentSalonId, serviceId, subServiceId);
    },

    concreteServiceLevel() {
      const { serviceId, subServiceId, concreteServiceId } = this.service;
      return this.getConcreteService(
        this.currentSalonId,
        serviceId,
        subServiceId,
        concreteServiceId
      );
    },

    concreteService() {
      const {
        serviceId,
        subServiceId,
        concreteServiceId,
        concreteServiceLevelId
      } = this.service;
      return this.getConcreteService(
        this.currentSalonId,
        serviceId,
        subServiceId,
        concreteServiceId,
        concreteServiceLevelId
      );
    },
    master() {
      const { masterId } = this.service;
      return this.getMaster(this.currentSalonId, masterId);
    },

    options() {
      const { optionsIds } = this.service;
      if (this.concreteService && this.concreteService.options) {
        return this.concreteService.options.filter(({ id }) =>
          optionsIds.includes(id)
        );
      }
      return [];
    }
  },
  methods: {
    ...mapMutations("client", [
      "currentEditServiceIdx",
      "deleteSelectedService"
    ]),
    handleEdit() {
      this.currentEditServiceIdx(this.idx);
    },

    handleDelete() {
      this.deleteSelectedService(this.idx);
    }
  }
};
</script>
